export class Subject {
    subjectId: number;
    subjectTitle: string;
    examTimeMinutes?: number;
    examQuestions?: number;
  
    constructor(qplId: number, subjectId: number, subjectTitle: string, examTimeMinutes?: number, examQuestions?: number) {
      // qplId parameter kept for backward compatibility but not stored
      this.subjectId = subjectId;
      this.subjectTitle = subjectTitle;
      this.examTimeMinutes = examTimeMinutes;
      this.examQuestions = examQuestions;
    }
  }